import { render, staticRenderFns } from "./SuccessBlock.vue?vue&type=template&id=47e54958&scoped=true"
import script from "./SuccessBlock.vue?vue&type=script&lang=js"
export * from "./SuccessBlock.vue?vue&type=script&lang=js"
import style0 from "./SuccessBlock.vue?vue&type=style&index=0&id=47e54958&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e54958",
  null
  
)

export default component.exports